// extracted by mini-css-extract-plugin
module.exports = {"cardHolder":"CurrentStudents_cardHolder__2ZTHn"};